import {Injectable} from '@angular/core';
import { ActivatedRouteSnapshot, RouterStateSnapshot, Router, ActivatedRoute } from '@angular/router';
import {UserService} from '../services/user/user.service';
import {NavigationService} from '../services/nav/navigation.service';
import {MyCognitoUser} from '../cognito-user-interfaces';
import {MessageService} from '../services/message/message.service';
import {TeacherDto, UserDto} from '@api/utisha-backend';
import UserTypeEnum = UserDto.UserTypeEnum;

@Injectable({
  providedIn: 'root'
})
export class TeacherGuard  {
  loggedIn: boolean;

  constructor(private userService: UserService,
              private navService: NavigationService,
              private messageService: MessageService,
              private activatedRoute: ActivatedRoute) {
  }

  private checkProfileComplete(user: TeacherDto, routerState: RouterStateSnapshot): boolean {
    if (!user.profileComplete && routerState.url.indexOf('profile') === -1) {
      this.navService.teacherProfile();
      this.messageService.info('Please complete your profile');
      return false;
    }
    // if (!user.settingsComplete && routerState.url.indexOf('/settings') === -1) {
    //   this.navService.teacherSettings();
    //   this.messageService.info('Please complete the settings');
    //   return false;
    // }
    return true;
  }

  async canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Promise<boolean> {
    const user = await this.userService.getUser();
    if (!user) {
      return Promise.resolve(false);
    }
    return Promise.resolve(user.userType === UserTypeEnum.Teacher && this.checkProfileComplete(user, state));
  }
}
